export type ProjectRuntimeConfig = {
  apiBaseUrl?: string;
  siteOrigin?: string;
  tenantId?: string;
  organizationId?: string;
  companyId?: string;
  actorId?: string;
  authMode?: string;
  authAuthority?: string;
  authAudience?: string;
  authClientId?: string;
  authRedirectUri?: string;
  authPostLogoutRedirectUri?: string;
  portalUrl?: string;
  agGridLicenseKey?: string;
};

export const runtimeConfig =
  typeof window !== 'undefined' && window.__PROJECT_CONFIG__
    ? window.__PROJECT_CONFIG__
    : undefined;

export function resolveRuntimeValue(...values: Array<string | undefined>): string | undefined {
  for (const value of values) {
    if (value && value.trim().length > 0) {
      return value;
    }
  }

  return undefined;
}
